import React from 'react';
import { View, Text, StyleSheet,Dimensions, Image,ImageBackground, StatusBar, TouchableWithoutFeedback } from 'react-native';
import PaymentStrip from './paymentStrip';
import { FOR_COURSE } from "./../store/constants";
import Grid from '@material-ui/core/Grid';

// import Icons from 'react-native-vector-icons/Ionicons';
// import { HeaderBackButton } from './../components'
const { width, height } = Dimensions.get('window');

const bgImage = require('./../assets/assets_png/file_ex.png');

const star = require('../assets/assets_png/star1.png');

const MaterialAndTestSeriesComponent = ({
    imageUrl,
    courseName,
    duration,
    ratings,
    isUserPaid,
    isFree,
    discounted,
    actualPrice,
    discountPrice,
    examName,
    isLibrary,
    makePayment,
    id
}) => {
    const price = discounted ? discountPrice : actualPrice

    return(
        <div
        className='material_comp'
        // style={styles.detailsComponent}
        >
        <ImageBackground 
            source={{uri: imageUrl}}
            style={{
                width: '100%',
                height: '100%' ,
                position: 'relative',
            }}           
          
            
        >
            <View 
            style={{
                position: 'absolute',
                top:0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.62)',
                zIndex: 1,                
            }}
        >
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: 33,
            }}>
                <View style={{marginLeft: 12, marginTop: 0}}>
                    {/* <HeaderBackButton position style={{height: 30, width: 30, borderWidth: 2, borderRadius: 8}} secondary />
                    <StatusBar barStyle='light-content' backgroundColor='rgba(0,0,0,0)' /> */}
                </View>
                <View
                  
                >
                    {
                        !isUserPaid && !isFree ?
                    <PaymentStrip 
                    price={price}
                    isFree={isFree}
                    discount={discountPrice}
                    actualPrice={actualPrice}
                    />   
                    : <View />
                    }
                </View>
            </View>
            <View style={styles.topicDetails}>
                <Text style={styles.examTitle}> {examName}</Text>
               <Text style={styles.topicTitle}
                ellipsizeMode="tail" numberOfLines={2}
               > 
                    {courseName}
                </Text>
            </View>
            <View style={styles.bottomComponent}>
                {
                    isLibrary ? 
                    
                    <View/>
                    :

                    <View style={{flexDirection: 'row', alignItems: 'center', }}>
                        <View style={styles.duration}>
                        <Text style={{fontSize: 11, fontWeight: '600', color: '#fff', fontSize: 10, fontWeight: '700'}}> {duration} Months</Text>
                        </View>
                        <View style={[styles.duration, {flexDirection:'row', alignItems: 'center',  marginHorizontal: 2,}]}>
                            {/* <Icons name='ios-star' size={10} color='gold' /> */}
                            <Text style={{color: '#fff', marginLeft: 4, fontSize: 10, fontWeight: '700'}}>{ratings || 4.5}</Text>
                        </View>
                        <View style={[styles.duration, {flexDirection:'row', alignItems: 'center'}]}>
                        {/* <Image source={star} style={{width: 12, height: 12,}}/> */}
                            {/* <Icons name='md-information-circle' color='#fff' /> */}
                            <Text style={{color: '#fff', marginLeft: 4, fontSize: 10, fontWeight: '700'}}>Know More</Text>
                        </View>
                    </View>
                }
                {
                   !isUserPaid && !isFree &&   
                   <TouchableWithoutFeedback
                    onPress={() => {
                        if(makePayment && typeof makePayment === 'function') makePayment(FOR_COURSE, id, price,);
                      
                    }}
                   >
                    <View style={styles.buyNow}>
                    <Text style={{fontSize: 14, fontWeight: '700', 
                    color: '#fff', }}>BUY NOW</Text>
                    </View>
                    </TouchableWithoutFeedback>
                }
                
            </View>
            </View>
        </ImageBackground>
        
        </div>
    )
}

export default MaterialAndTestSeriesComponent;

const styles = StyleSheet.create({
    detailsComponent: {
        width: '100%',     
        height: 350,
        flexDirection: 'column',         
        marginTop: -5     
    },
    topicDetails: {
        flex: 1,
        marginHorizontal: 10,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginTop: 16
      
    },
    examTitle: {
        fontSize: 22,
        fontWeight: '700',
        color: '#ffe200',
        textTransform:  'uppercase'
    },
    topicTitle: {
        textTransform:  'uppercase',
        fontSize: 16,
        fontWeight: '600',
        color: '#fff',
        marginLeft: 5,
    },
    bottomComponent: {
        justifyContent: 'space-between',
        flexDirection: 'row',
       
       
    },
    duration: {
       borderWidth: 1,
       borderColor: '#fff',
       borderRadius: 10,
       height: 22,
       paddingHorizontal: 8,
       marginHorizontal: 1.5,
       alignItems: 'center',
       justifyContent :'center',
       marginHorizontal: 10,
       marginBottom: 10

    },
    buyNow: {
        // width: 120,
        paddingHorizontal: width <= 400 ? 10  :  30,
        height: 40,
        backgroundColor: 'green',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderTopStartRadius: 50,
       
    }
})